import React from 'react';
import resume from '../../data/resume.pdf';

export default function Biography() {
  return (
    <div className="card--bio--section">
      <div className="presentation--text">
          <h2 className="card_title mb-4">About me</h2>
          <p>I'm <strong>David Piredda</strong>, a young junior frontend developer with a strong passion for design.</p>
          <p>Since the early years of my academic career I've been loving the research for order and rationalization in the process of solving complex problems, related to an architecture project as well as urban design.
            <br />Now, as a frontend dev, I’m trying to combine this research with my passion for the web and development universe.</p>
          <p>I love the linear and consequential logic of the code from which I can create simple, clean and clear interfaces.</p>
          <div className="buttons_container">
            <a href={resume} target='_blank' rel="noreferrer" type='text/pdf'>
              <i className="bi bi-download link--icons"></i>
              Download CV
            </a>
            <a href="#Contact">
              <i className="bi bi-code link--icons"></i>
              Hire me!
            </a>
          </div>
      </div>
    </div>
  )
}
